<template>
  <div class="notifications-panel">
    <SidepanelHeader
      icon="notification"
      iconType="outlined"
      :count="notifications.length"
      title-key="notifications.notifications"
    />
    <div class="delete-container" v-if="notifications.length > 0">
      <ButtonDeleteSidepanelItems :count="notifications.length" @on-click="clearAll" />
    </div>
    <NoDataComponent
      v-if="notifications.length === 0"
      title-key="notifications.noNewNotifications"
      description-key="notifications.notificationsAppearHere"
    />
    <div class="notifications-list">
      <NotificationCard v-for="notification in notifications" :key="notification.id" :notification="notification" />
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue';

import useNotifications from '~/composables/useNotifications';
import NotificationCard from '~/components/conversation/notificationsPanel/NotificationCard';
import SidepanelHeader from '~/components/conversation/sidepanelGeneralComponents/SidepanelHeader.vue';
import ButtonDeleteSidepanelItems from '~/components/conversation/sidepanelGeneralComponents/ButtonDeleteSidepanelItems.vue';
import NoDataComponent from '~/components/conversation/sidepanelGeneralComponents/NoDataComponent.vue';

export default {
  components: { NoDataComponent, ButtonDeleteSidepanelItems, SidepanelHeader, NotificationCard },
  setup() {
    const { notifications, markAllAsRead, removeAllNotifications, removeAllToasts } = useNotifications();

    const clearAll = () => {
      removeAllNotifications();
      removeAllToasts();
    };

    onMounted(() => {
      const notificationIds = notifications.value.filter(({ readAt }) => !readAt).map(({ id }) => id);

      if (notificationIds?.length) {
        markAllAsRead(notificationIds);
      }
    });

    return {
      notifications,
      clearAll,
    };
  },
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}

.notifications-panel {
  @include media-breakpoint-up('sm') {
    display: flex;
  }

  max-height: calc(100vh - 80px);

  // take into consideration the margins
  height: 100%;
  display: none;
  flex-direction: column;
  background-color: $bb-neutral-6;
  border-radius: $bb-spacing-8;
  border: 1px solid #cecdcb;
  box-shadow: 0 0 $bb-spacing-2 0 #0000001a;
  align-items: flex-start;
  min-width: 476px;
  max-width: 476px;
  overflow: hidden;
  z-index: 1000;

  .delete-container {
    padding: $bb-spacing-2 $bb-spacing-4;
    background-color: $bb-neutral-0;
    width: 100%;
  }

  .notifications-list {
    display: flex;
    flex-direction: column;
    gap: $bb-spacing-2;
    width: 100%;
    padding: $bb-spacing-2 $bb-spacing-4;
    overflow: auto;
  }
}
</style>
